<template>
    <v-responsive class="border rounded">
  <v-app class="bg-background">
    <NuxtRouteAnnouncer />

    <v-overlay :model-value="isLoading"
               contained
               persistent
               class="align-center justify-center"
               style="z-index: 9999;background: rgba(0,0,0,0.5);">
      <v-progress-circular color="primary"
                           size="64"
                           indeterminate />
    </v-overlay>

    <HeaderCard :items="items"
                :cart-count="cartCount"
                :is-show-counter="isShowCounter"
                @go-to-cart="goToCart" />
    <v-main>
      <v-container fluid>
        <NuxtPage :key="$route.fullPath" />
      </v-container>
    </v-main>
    <v-bottom-navigation elevation="3"
                         fixed
                         max-width="100vw"
                         app
                         :active="mobile"
                         grow
                         style="z-index: 1010!important;"
                         role="navigation"
                         aria-label="Mobile navigation menu">
      <v-btn v-for="(item, i) in items"
             :key="i"
             :value="item"
             :to="item.props.to"
             class="position-relative"
             color="#2d2d2d">
        <v-icon :icon="item.icon" />

        <span v-if="item.title === 'Cart'"
              class="badge">{{ cartCount }}</span>
      </v-btn>
    </v-bottom-navigation>
    <v-footer app
              :class="mobile ? 'position-relative' : ''"
              style="z-index:1000!important">
      <div class="d-flex flex-grow-1 justify-center py-1">
        <small>&copy; Copyright 2020, Explicit Lures Designed By: <a class="text-error"
             href="http://www.linkedin.com/in/thecodergabe-connect">TheCoderGabe</a></small>
      </div>
    </v-footer>
  </v-app>
    </v-responsive>
</template>

<script lang="ts" type="module" setup>
import { useLoading } from '~/composables/useLoading'
import { useDisplay } from 'vuetify'
import { computed, onMounted, useCart } from '#imports'
import HeaderCard from './components/headerCard.vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const { isLoading } = useLoading()
const cart = useCart()
const { mobile } = useDisplay()

const items = [
  {
    title: 'Home',
    icon: 'mdi-home',
    props: {
      to: { name: 'index' },
      mobile: true,
    },
  },
  {
    title: 'Lures',
    icon: 'mdi-fish',
    props: {
      to: { name: 'lures' },
      mobile: false,
    },
  },
  {
    title: 'Swag',
    icon: 'mdi-tshirt-crew',
    props: {
      to: { name: 'swag' },
      mobile: false,
    },
  },
  {
    title: 'About Us',
    icon: 'mdi-account-group',
    props: {
      to: { name: 'about' },
      mobile: false,
    },
  },
  {
    title: 'Cart',
    icon: 'mdi-shopping-outline',
    props: {
      to: { name: 'cart' },
      mobile: true,
    },
  },
]

function goToCart() {
  router.push({ name: 'cart' })
}

const cartCount = computed(() => cart.cartCount.value)
const isShowCounter = computed(() => cartCount.value > 0)

onMounted(() => {
  if (!cart.items.value.length) {
    cart.initializeCart()
  }
})
</script>

<style scoped>
.logo {
  max-height: 50px;
}

.badge {
  position: absolute;
  top: 5px;
  right: 18px;
  background-color: #993826;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  text-align: center;
  color: white;
  padding: 3px 0;
}

.icon-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
}

:deep(.v-toolbar__content) {
  justify-content: space-between;
}
</style>
